import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  Row,
  Col,
  Card,
  Drawer,
  Descriptions,
  Anchor,
  Tag,
  Space,
  Button,
  Switch,
  Form,
  Input,
  Select,
  notification,
} from "antd";
import { Table } from "ant-table-extensions";
import http from "../../../helpers/http";
import helper from "../../../helpers/helper";
import config from "../../../config/config";
import moment from "moment";
import { createExportFields } from "./exportCSV/exportFields";

function Index() {
  const [loading, setloading] = useState(false);
  const [drawerOpen, setdraweropen] = useState(false);
  const [datas, setDatas] = useState([]);
  const [data, setData] = useState({});
  const [user, setUser] = useState({});
  const [btnloading, setbtnloading] = useState(false);
  const [form] = Form.useForm();
  const [searchText, setSearchText] = useState("");

  // Module configuration for 2026
  const moduleNamePural = "Application Form 2026";
  const base_url = config.api_url + "admin/2026/users"; //without trailing slash
  const image_url = config.api_url + "uploads/user-2026/"; //with trailing slash

  const { Option } = Select;

  // ================================
  // View single application detail
  // ================================
  const handleView = async (id) => {
    const { data } = await http.get(`${base_url}/${id}`);

    if (data) {
      setData(data);
      console.log(data);
      setdraweropen(true);
    }
  };

  // ================================
  // Review Highlights
  // ================================

  const isBrand = data?.application_track === "brand";
  const brandTrack = data?.brand_track?.toLowerCase() || "";
  const isGrow = brandTrack === "grow";

  const isImagine = brandTrack === "imagine";

  const hasBrandTrack = ["grow", "imagine"].includes(brandTrack);

  const isDesign = data?.application_track === "design";

  const fundingOptions = isGrow
    ? data?.grow_external_funding || []
    : isImagine
      ? data?.imagine_external_funding || []
      : [];

  const fundingOther = isGrow
    ? data?.grow_external_funding_other
    : data?.imagine_external_funding_other;

  // const fundingDetails = isImagine
  //   ? data?.imagine_external_funding_details
  //   : "";

  const priorityFundingOptions = [
    "Strategic corporate investor or corporate venture arm",
    "Currently in active conversations — not yet closed",
  ];

  const hasPriorityFunding = fundingOptions.some((item) =>
    priorityFundingOptions.includes(item)
  );

  // Generate social profile URL from handle or full URL
  function getSocialLink(platform, value) {
    if (!value) return null;
    if (value.startsWith("http")) return value;

    const username = value.startsWith("@") ? value.slice(1) : value;

    switch (platform) {
      case "instagram":
        return `https://www.instagram.com/${username}`;
      case "facebook":
        return `https://www.facebook.com/${username}`;
      case "youtube":
        return `https://www.youtube.com/@${username}`;
      case "tiktok":
        return `https://www.tiktok.com/@${username}`;
      case "linkedin":
        return `https://www.linkedin.com/in/${username}`;
      case "snapchat":
        return `https://www.snapchat.com/add/${username}`;
      default:
        return value;
    }
  }

  // Render a clickable link, returns "-" if value is empty
  const renderLink = (url, label) => {
    if (!url) return "-";
    const href = url.startsWith("http") ? url : `https://${url}`;
    return (
      <a href={href} target="_blank" rel="noopener noreferrer">
        {label || url}
      </a>
    );
  };

  const renderSnapchatLink = (value) => {
    if (!value) return "-";

    const input = value.trim();

    // If it's already a valid URL, use it directly
    if (/^https?:\/\//i.test(input)) {
      return (
        <a href={input} target="_blank" rel="noopener noreferrer">
          {input}
        </a>
      );
    }

    // Otherwise treat it as a username
    const username = input.replace(/^@/, "");

    const url = `https://www.snapchat.com/add/${username}`;

    return (
      <a href={url} target="_blank" rel="noopener noreferrer">
        {url}
      </a>
    );
  };

  const formatPrimaryCategory = (record) => {
    const track = record?.application_track?.toLowerCase();
    const brandTrack = record?.brand_track?.toLowerCase();

    if (track === "brand") {
      if (brandTrack === "grow") return "Grow";
      if (brandTrack === "imagine") return "Imagine";
      return "Not Selected";
    }

    if (track === "design") {
      return "Design";
    }

    if (track === "breakthrough") {
      return "Breakthrough";
    }

    return "-";
  };

  // Render a clickable social link using the getSocialLink helper
  const renderSocialLink = (platform, value) => {
    if (!value) return "-";
    const url = getSocialLink(platform, value);
    return (
      <a href={url} target="_blank" rel="noopener noreferrer">
        {url}
      </a>
    );
  };

  // Extract original file name from file object or string
  const getFileName = (fileObj) => {
    if (!fileObj) return "-";
    if (typeof fileObj === "object" && fileObj !== null) {
      return fileObj.original_name || fileObj.filename || "-";
    }
    return fileObj;
  };

  // Extract stored filename for building download URL
  const getStoredFileName = (fileObj) => {
    if (!fileObj) return "";
    if (typeof fileObj === "object" && fileObj !== null) {
      return fileObj.filename || "";
    }
    return fileObj;
  };

  // Format boolean value as Yes/No
  const formatBoolean = (value) => {
    if (value === true || value === "yes" || value === "true") return "Yes";
    if (value === false || value === "no" || value === "false") return "No";
    return "-";
  };

  // Format application track value for display
  const formatTrack = (track) => {
    const trackMap = {
      brand: "Brand",
      design: "Design",
      breakthrough: "Breakthrough",
    };
    return trackMap[track?.toLowerCase()] || "-";
  };

  // Close drawer and reset data
  const handleDrawerClose = () => {
    setData({});
    setdraweropen(false);
  };

  const filteredData = datas.filter((item) => {
    const search = searchText.toLowerCase();

    const name =
      `${item.first_name || ""} ${item.last_name || ""}`.toLowerCase();
    const email = (item.email || "").toLowerCase();
    const track = formatTrack(item.application_track).toLowerCase();
    const category = formatPrimaryCategory(item).toLowerCase();

    const status =
      item.status === "registered"
        ? "registered"
        : item.status === "completed"
          ? "completed"
          : "partially filled";

    return (
      name.includes(search) ||
      email.includes(search) ||
      track.includes(search) ||
      category.includes(search) ||
      status.includes(search)
    );
  });

  // ================================
  // Fetch all applications with filters
  // ================================
  const fetchDatas = async (status = "all", category = "all") => {
    setloading(true);

    const data = await http.get(
      `${base_url}?status=${status}&category=${category}`
    );

    if (data) {
      setDatas(data.data);
      console.log(data.data);
    }

    setloading(false);
  };

  useEffect(() => {
    fetchDatas();
    setUser(helper.getUser());
    console.log(helper.getUser());
  }, []);

  // ================================
  // Table Columns Definition
  // ================================
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => {
        return `${record.first_name || ""}  ${record.last_name || ""}`;
      },
      sorter: (a, b) => a.first_name?.localeCompare(b.first_name),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: (a, b) => a.email?.localeCompare(b.email),
    },
    // Application Track column (replaces old Category logic)
    {
      title: "Track",
      dataIndex: "application_track",
      key: "application_track",
      render: (text, record) => {
        return formatTrack(record.application_track);
      },
    },
    {
      title: "Primary Category",
      key: "primary_category",
      render: (_, record) => formatPrimaryCategory(record),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text, record) => {
        return record.status == "registered" ? (
          <Tag color="red">{record.status}</Tag>
        ) : record.status == "completed" ? (
          <Tag color="green">{record.status}</Tag>
        ) : (
          <Tag color="orange">partially filled</Tag>
        );
      },
    },
    {
      title: "Created At",
      render: (text, record) => {
        return helper.ISTDate(record.createdAt);
      },
      key: "createdAt",
      sorter: (a, b) => moment(a.createdAt).unix() - moment(b.createdAt).unix(),
    },
    {
      title: "Completed At",
      render: (text, record) => {
        return helper.ISTDate(record.updatedAt);
      },
      key: "updatedAt",
      sorter: (a, b) => moment(a.updatedAt).unix() - moment(b.updatedAt).unix(),
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          <Button
            type="primary"
            onClick={() => {
              handleView(record._id);
            }}
          >
            View Detail
          </Button>
        </Space>
      ),
    },
  ];

  const fields = createExportFields({
    helper,
    imageUrl: image_url,
    formatTrack,
  });

  // ================================
  // Filter form submission
  // ================================
  const handleSubmit = async (value) => {
    setbtnloading(true);

    await fetchDatas(value.status, value.category);

    setbtnloading(false);
  };

  // ================================
  // Status toggle handler
  // ================================
  const handleStatus = async (key, value, id) => {
    const data = value ? 1 : 0;

    const result = await http.put(`${base_url}/status/${id}`, {
      [key]: data,
    });

    if (result) {
      notification["success"]({
        message: "Status Changed Successfully",
      });
    }
  };

  // Check if application track is breakthrough (for conditional rendering)
  const isBreakthrough =
    data?.application_track?.toLowerCase() === "breakthrough";

  // Check if organisation type requires institution details
  const isInstitutionType =
    data?.organisation_type ===
      "University / Research Institution / Academic Lab" ||
    data?.organisation_type ===
      "Pre-commercial spin-out from a university or research institution";

  // Check if organisation type requires company registration date
  const isCompanyType =
    data?.organisation_type === "Startup (incorporated, under 3 years)" ||
    data?.organisation_type === "Company (registered entity, 3+ years)" ||
    data?.organisation_type === "Fragrance House" ||
    data?.organisation_type === "Other";

  const renderMultiChoice = (items) => {
    if (!items?.length) return "-";

    return (
      <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
        {items.map((item, index) => (
          <div key={index}> • {item}</div>
        ))}
      </div>
    );
  };

  const renderDistributionChannels = (items) => {
    if (!items?.length) return "-";

    return (
      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        {items.map((item, index) => (
          <div key={index}>
            • {item.channel || "-"} ({item.percentage || 0}%)
          </div>
        ))}
      </div>
    );
  };

  return (
    <div>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
        <Breadcrumb.Item>Leads</Breadcrumb.Item>
        <Breadcrumb.Item>{moduleNamePural}</Breadcrumb.Item>
      </Breadcrumb>
      <Row gutter={15}>
        <Col span={24}>
          <div className="site-card-border-less-wrapper">
            <Card title={moduleNamePural} bordered={false}>
              <Form layout="inline" form={form} onFinish={handleSubmit}>
                <Form.Item label="Status:" name="status" initialValue="all">
                  <Select style={{ width: 180 }}>
                    <Option value="all">All</Option>
                    <Option value="registered">Registered</Option>
                    <Option value="partial">Partially Filled</Option>
                    <Option value="completed">Completed</Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  label="Primary Category:"
                  name="category"
                  initialValue="all"
                >
                  <Select
                    style={{ width: 220 }}
                    dropdownStyle={{ minWidth: 180 }}
                  >
                    <Option value="all">All</Option>
                    <Option value="grow">Grow</Option>
                    <Option value="imagine">Imagine</Option>
                    <Option value="design">Design</Option>
                    <Option value="breakthrough">Breakthrough</Option>
                  </Select>
                </Form.Item>

                <Form.Item>
                  <Button type="primary" htmlType="submit" loading={btnloading}>
                    Filter
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <div className="site-card-border-less-wrapper">
            <Card bordered={false}>
              {/* <Row justify="end" style={{ marginBottom: 15 }}>
                <Col span={8}>
                  <Input.Search
                    placeholder="Search..."
                    allowClear
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </Col>
              </Row> */}

              <Table
                rowKey={(record) => record._id}
                columns={columns}
                // dataSource={datas}
                dataSource={filteredData}
                loading={loading}
                pagination={{
                  defaultPageSize: 10,
                  pageSizeOptions: ["10", "20", "50", "100"],
                  showSizeChanger: true,
                  // showQuickJumper: true,
                  showTotal: (total, range) =>
                    `${range[0]}-${range[1]} of ${total} applications`,
                  position: ["bottomRight"],
                }}
                title={() => (
                  <Row justify="end">
                    <Input.Search
                      placeholder="Search..."
                      allowClear
                      style={{ width: 300 }}
                      onChange={(e) => setSearchText(e.target.value)}
                    />
                  </Row>
                )}
                // exportableProps={
                //   user?.permission?.includes("export")
                //     ? {
                //         showColumnPicker: false,
                //         fields,
                //         fileName: moduleNamePural,
                //       }
                //     : null
                // }
                exportableProps={{
                  showColumnPicker: false,
                  fields,
                  fileName: moduleNamePural,
                  searchable: true,
                }}
              />
            </Card>

            <Drawer
              title="Lead Details"
              placement="right"
              onClose={handleDrawerClose}
              visible={drawerOpen}
              size="large"
              width={1000}
            >
              {data && (
                <>
                  {/* ================================ */}
                  {/* Admin Review Highlights */}
                  {/* ================================ */}
                  {(isBrand ||
                    data?.application_track === "design" ||
                    data?.application_track === "breakthrough") && (
                    <Descriptions
                      title="Review Highlights"
                      bordered
                      size="small"
                      column={1}
                      style={{ marginBottom: 20 }}
                    >
                      <Descriptions.Item label="Primary Category">
                        {isBrand ? (
                          !hasBrandTrack ? (
                            <Tag>Not Selected</Tag>
                          ) : isGrow ? (
                            <Tag color="green">Grow</Tag>
                          ) : (
                            <Tag color="blue">Imagine</Tag>
                          )
                        ) : isDesign ? (
                          <Tag color="purple">Design</Tag>
                        ) : (
                          <Tag color="geekblue">Breakthrough</Tag>
                        )}
                      </Descriptions.Item>

                      {isBrand && ["grow", "imagine"].includes(brandTrack) && (
                        <>
                          {/* External Funding */}
                          {fundingOptions.length > 0 && (
                            <Descriptions.Item label="External Funding">
                              {fundingOptions.map((item) => (
                                <Tag
                                  key={item}
                                  color={
                                    priorityFundingOptions.includes(item)
                                      ? "green"
                                      : "default"
                                  }
                                >
                                  {item}
                                </Tag>
                              ))}
                            </Descriptions.Item>
                          )}

                          {/* Other Funding Details */}
                          {fundingOther && (
                            <Descriptions.Item label="Other Funding Details">
                              {fundingOther}
                            </Descriptions.Item>
                          )}

                          {/* Imagine Only */}
                          {/* {isImagine && fundingDetails && (
                            <Descriptions.Item label="Funding Amount / Investor / Date">
                              {fundingDetails}
                            </Descriptions.Item>
                          )} */}

                          {/* Grow Only */}
                          {isGrow && (
                            <Descriptions.Item label="Product Samples Available">
                              <Tag
                                color={
                                  data.grow_product_samples ? "green" : "red"
                                }
                              >
                                {formatBoolean(data.grow_product_samples)}
                              </Tag>
                            </Descriptions.Item>
                          )}
                        </>
                      )}

                      <Descriptions.Item label="Visionary Award Eligibility">
                        {data.has_woman_founder !== true ? (
                          <Tag color="red">Not Eligible (No Woman Founder)</Tag>
                        ) : data.visionary_opt_out === true ? (
                          <Tag color="orange">Not Eligible (Opted Out)</Tag>
                        ) : (
                          <Tag color="green">Eligible</Tag>
                        )}
                      </Descriptions.Item>

                      {data.application_track === "design" && (
                        <Descriptions.Item label="Finalist Availability">
                          <Tag
                            color={
                              data.design_finalist_availability?.startsWith(
                                "Yes"
                              )
                                ? "green"
                                : "red"
                            }
                          >
                            {data.design_finalist_availability || "-"}
                          </Tag>
                        </Descriptions.Item>
                      )}
                    </Descriptions>
                  )}

                  {/* ================================ */}
                  {/* Step 1 - Founder Details */}
                  {/* ================================ */}
                  <Descriptions
                    title="Step 1 - Information"
                    bordered
                    column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                    size="small"
                  >
                    {/* Personal Details */}

                    <Descriptions.Item label="First Name">
                      {data.first_name || "-"}
                    </Descriptions.Item>

                    <Descriptions.Item label="Last Name">
                      {data.last_name || "-"}
                    </Descriptions.Item>

                    <Descriptions.Item label="Email">
                      {data.email ? (
                        <a
                          href={`mailto:${data.email}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {data.email}
                        </a>
                      ) : (
                        "-"
                      )}
                    </Descriptions.Item>

                    <Descriptions.Item label="Phone">
                      {`${data.country_code || ""} ${data.phone || "-"}`}
                    </Descriptions.Item>

                    <Descriptions.Item label="Title / Designation">
                      {data.title || "-"}
                    </Descriptions.Item>

                    <Descriptions.Item label="Are you currently a university student?">
                      {formatBoolean(data.is_university_student)}
                    </Descriptions.Item>

                    {(data.is_university_student === true ||
                      data.is_university_student === "yes") && (
                      <Descriptions.Item label="University Name">
                        {data.university_name || "-"}
                      </Descriptions.Item>
                    )}

                    {/* Co-Founder */}

                    <Descriptions.Item label="Do you have a co-founder or co-founders?">
                      {formatBoolean(data.has_co_founders)}
                    </Descriptions.Item>

                    {data.has_co_founders === true &&
                      data.co_founders?.length > 0 && (
                        <Descriptions.Item label="Co-Founders">
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 12,
                            }}
                          >
                            {data.co_founders.map((cf, index) => (
                              <div
                                key={index}
                                style={{
                                  border: "1px solid #f0f0f0",
                                  borderRadius: 6,
                                  padding: "12px 16px",
                                  background: "#fafafa",
                                }}
                              >
                                <div
                                  style={{ fontWeight: 600, marginBottom: 8 }}
                                >
                                  Co-Founder {index + 1}
                                </div>

                                <div style={{ marginBottom: 6 }}>
                                  <span>Name:</span> {cf?.full_name || "-"}
                                </div>

                                <div style={{ marginBottom: 6 }}>
                                  <span>Role / Title:</span>{" "}
                                  {cf?.designation || "-"}
                                </div>

                                <div>
                                  <span>Email:</span>{" "}
                                  {cf?.email ? (
                                    <a
                                      href={`mailto:${cf.email}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {cf.email}
                                    </a>
                                  ) : (
                                    "-"
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                        </Descriptions.Item>
                      )}

                    {/* Company Information */}

                    <Descriptions.Item label="Do you have a woman founder on your team?">
                      {formatBoolean(data.has_woman_founder)}
                    </Descriptions.Item>

                    <Descriptions.Item label="Company Name">
                      {data.company_name || "-"}
                    </Descriptions.Item>

                    <Descriptions.Item label="Different Brand Name">
                      {formatBoolean(data.has_different_brand_name)}
                    </Descriptions.Item>

                    {(data.has_different_brand_name === true ||
                      data.has_different_brand_name === "yes") && (
                      <Descriptions.Item label="Brand Name">
                        {data.brand_name || "-"}
                      </Descriptions.Item>
                    )}

                    <Descriptions.Item label="What type of entity are you?">
                      {data.entity_type || "-"}
                    </Descriptions.Item>

                    <Descriptions.Item label="GST Number">
                      {data.gst_no || "-"}
                    </Descriptions.Item>

                    <Descriptions.Item label="Year Business Started">
                      {data.company_start_year || "-"}
                    </Descriptions.Item>

                    <Descriptions.Item label="Number of Employees?">
                      {data.employee_count || "-"}
                    </Descriptions.Item>

                    {/* Address */}

                    <Descriptions.Item label="Country">
                      {data.country || "-"}
                    </Descriptions.Item>

                    <Descriptions.Item label="State">
                      {data.state || "-"}
                    </Descriptions.Item>

                    <Descriptions.Item label="City">
                      {data.city || "-"}
                    </Descriptions.Item>

                    <Descriptions.Item label="Street Address">
                      {data.street_address || "-"}
                    </Descriptions.Item>

                    <Descriptions.Item label="Post Code">
                      {data.zip || "-"}
                    </Descriptions.Item>

                    <Descriptions.Item label="How did you discover BEAUTY&YOU India?">
                      {/* {data.discovery_sources?.length
                        ? data.discovery_sources.join(", ")
                        : "-"} */}
                      {renderMultiChoice(data.discovery_sources)}
                    </Descriptions.Item>

                    {data.discovery_sources?.includes("Other") && (
                      <Descriptions.Item label="How did you discover BEAUTY&YOU India? (Other)">
                        {data.discovery_source_other || "-"}
                      </Descriptions.Item>
                    )}
                    
                    <Descriptions.Item label="IP Address">
                      {data.ip_address || "-"}
                    </Descriptions.Item>

                    <Descriptions.Item label="User Agent">
                      {data.user_agent || "-"}
                    </Descriptions.Item>
                  </Descriptions>

                  {/* ================================ */}
                  {/* Step 2 - Application Track */}
                  {/* ================================ */}
                  <Descriptions
                    title="Step 2 - Information"
                    bordered
                    column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                    size="small"
                    style={{ marginTop: 20 }}
                  >
                    <Descriptions.Item label="Selected Track">
                      {formatTrack(data.application_track)}
                    </Descriptions.Item>
                  </Descriptions>

                  {/* ================================ */}
                  {/* Step 3 - Visionary + Organisation Details */}
                  {/* ================================ */}
                  <Descriptions
                    title="Step 3 - Information"
                    bordered
                    column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                    size="small"
                    style={{ marginTop: 20 }}
                  >
                    {/* Visionary opt out */}
                    <Descriptions.Item label="Visionary Women's Award Opt Out">
                      {data.visionary_opt_out === undefined ||
                      data.visionary_opt_out === null ||
                      data.visionary_opt_out === ""
                        ? "-"
                        : data.visionary_opt_out
                          ? "Yes"
                          : "No"}
                    </Descriptions.Item>

                    {/* Organisation details (Breakthrough track only) */}
                    {isBreakthrough && (
                      <>
                        <Descriptions.Item label="What best describes your organisation type?">
                          {data.organisation_type || "-"}
                        </Descriptions.Item>

                        {/* Other organisation type */}
                        {data.organisation_type === "Other" && (
                          <Descriptions.Item label="What best describes your organisation type? (Other)">
                            {data.organisation_type_other || "-"}
                          </Descriptions.Item>
                        )}

                        {/* Funding stage (Startup only) */}
                        {data.organisation_type ===
                          "Startup (incorporated, under 3 years)" && (
                          <Descriptions.Item label="If startup, specify funding stage">
                            {data.funding_stage || "-"}
                          </Descriptions.Item>
                        )}

                        {/* Institution details (University / Pre-commercial only) */}
                        {isInstitutionType && (
                          <>
                            <Descriptions.Item label="Institution Name">
                              {data.institution_name || "-"}
                            </Descriptions.Item>
                            <Descriptions.Item label="Department / Faculty">
                              {data.department || "-"}
                            </Descriptions.Item>
                            <Descriptions.Item label="Principal Investigator / Lead Researcher Name">
                              {data.principal_investigator || "-"}
                            </Descriptions.Item>
                            <Descriptions.Item label="Has your institution's technology transfer or commercialisation office been involved in this work?">
                              {data.technology_transfer_involved || "-"}
                            </Descriptions.Item>
                          </>
                        )}

                        {/* Company registration date (Startup/Company/Fragrance/Other) */}
                        {isCompanyType && (
                          <Descriptions.Item label="Date of Company Registration">
                            {data.company_registration_date || "-"}
                          </Descriptions.Item>
                        )}
                      </>
                    )}
                  </Descriptions>

                  {/* ===================================================== */}
                  {/* Step 4 - Information */}
                  {/* ===================================================== */}

                  <Descriptions
                    title="Step 4 - Information"
                    bordered
                    column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                    size="small"
                    style={{ marginTop: 20 }}
                  >
                    {/* Always Visible */}

                    <Descriptions.Item label="Company Website">
                      {renderLink(data.company_website)}
                    </Descriptions.Item>

                    <Descriptions.Item label="LinkedIn">
                      {renderLink(data.linkedin)}
                    </Descriptions.Item>

                    {/* Brand & Design Only */}

                    {(data.application_track === "brand" ||
                      data.application_track === "design") && (
                      <>
                        <Descriptions.Item label="Instagram">
                          {renderLink(data.instagram)}
                        </Descriptions.Item>

                        <Descriptions.Item label="YouTube">
                          {renderLink(data.youtube)}
                        </Descriptions.Item>

                        <Descriptions.Item label="TikTok">
                          {renderLink(data.tiktok)}
                        </Descriptions.Item>

                        <Descriptions.Item label="Facebook">
                          {renderLink(data.facebook)}
                        </Descriptions.Item>

                        {/* Snapchat may be a username or a URL */}

                        <Descriptions.Item label="Snapchat">
                          {renderSnapchatLink(data.snapchat)}
                        </Descriptions.Item>

                        <Descriptions.Item label="Other Social">
                          {renderLink(data.other_social)}
                        </Descriptions.Item>

                        {/* <Descriptions.Item label="Intro Video">
                          {renderLink(data.intro_video_url)}
                        </Descriptions.Item> */}
                      </>
                    )}

                    {/* Breakthrough Only */}

                    {data.application_track === "breakthrough" && (
                      <>
                        <Descriptions.Item label="Research Publications">
                          {renderLink(data.research_publications_link)}
                        </Descriptions.Item>

                        <Descriptions.Item label="Other Relevant Link">
                          {renderLink(data.other_relevant_link)}
                        </Descriptions.Item>
                      </>
                    )}

                    {/* ===================================================== */}
                    {/* Business Overview Files */}
                    {/* ===================================================== */}

                    <Descriptions.Item label="Business Overview File">
                      {data.business_overview_files?.length > 0 ? (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 8,
                          }}
                        >
                          {data.business_overview_files.map((file, index) => (
                            <div
                              key={index}
                              style={{
                                padding: "8px 12px",
                                border: "1px solid #f0f0f0",
                                borderRadius: 6,
                                background: "#fafafa",
                              }}
                            >
                              <a
                                href={image_url + getStoredFileName(file)}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {getFileName(file)}
                              </a>
                            </div>
                          ))}
                        </div>
                      ) : (
                        "-"
                      )}
                    </Descriptions.Item>

                    {(data.application_track === "brand" ||
                      data.application_track === "design") && (
                      <Descriptions.Item label="Intro Video">
                        {renderLink(data.intro_video_url)}
                      </Descriptions.Item>
                    )}

                    {/* ===================================================== */}
                    {/* Founder Headshots */}
                    {/* ===================================================== */}

                    <Descriptions.Item label="Founder Headshots">
                      {data.founder_headshot_files?.length > 0 ? (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 8,
                          }}
                        >
                          {data.founder_headshot_files.map((file, index) => (
                            <div
                              key={index}
                              style={{
                                padding: "8px 12px",
                                border: "1px solid #f0f0f0",
                                borderRadius: 6,
                                background: "#fafafa",
                              }}
                            >
                              <a
                                href={image_url + getStoredFileName(file)}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {getFileName(file)}
                              </a>
                            </div>
                          ))}
                        </div>
                      ) : (
                        "-"
                      )}
                    </Descriptions.Item>
                  </Descriptions>

                  {/* ================================ */}
                  {/* Step 5 - Information */}
                  {/* ================================ */}
                  {(data.application_track === "brand" ||
                    data.application_track === "design" ||
                    data.application_track === "breakthrough") && (
                    <Descriptions
                      title="Step 5 - Information"
                      bordered
                      column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                      size="small"
                      style={{ marginTop: 20 }}
                    >
                      {/* ===================================================== */}
                      {/* Brand Track */}
                      {/* ===================================================== */}

                      {data.application_track === "brand" && (
                        <>
                          <Descriptions.Item label="What's your current trading status?">
                            {data.trading_status || "-"}
                          </Descriptions.Item>

                          <Descriptions.Item label="Which best describes your focus area?">
                            {/* {data.focus_areas?.length
                              ? data.focus_areas.join(", ")
                              : "-"} */}
                            {renderMultiChoice(data.focus_areas)}
                          </Descriptions.Item>

                          {data.focus_areas?.includes("Other") && (
                            <Descriptions.Item label="Which best describes your focus area? (Other)">
                              {data.focus_area_other || "-"}
                            </Descriptions.Item>
                          )}
                        </>
                      )}

                      {/* ===================================================== */}
                      {/* Design Track */}
                      {/* ===================================================== */}

                      {data.application_track === "design" && (
                        <>
                          <Descriptions.Item label="Are you applying as an individual or a collective/studio?">
                            {data.design_applicant_type || "-"}
                          </Descriptions.Item>

                          {data.design_applicant_type ===
                            "Collective or studio" && (
                            <Descriptions.Item label="Who are the members of your collective, and what is each person's role?">
                              {data.collective_members || "-"}
                            </Descriptions.Item>
                          )}

                          <Descriptions.Item label="Full Name / Collective Name">
                            {data.creative_name || "-"}
                          </Descriptions.Item>

                          <Descriptions.Item label="How would you describe your creative practice?">
                            {/* {data.creative_practices?.length
                              ? data.creative_practices.join(", ")
                              : "-"} */}
                            {renderMultiChoice(data.creative_practices)}
                          </Descriptions.Item>

                          {data.creative_practices?.includes("Other") && (
                            <Descriptions.Item label="How would you describe your creative practice? (Other)">
                              {data.creative_practice_other || "-"}
                            </Descriptions.Item>
                          )}

                          <Descriptions.Item label="Portfolio Link(s)">
                            {data.portfolio_links?.filter(Boolean).length ? (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 4,
                                }}
                              >
                                {data.portfolio_links
                                  .filter(Boolean)
                                  .map((link, index) => (
                                    <div key={index}>
                                      •{" "}
                                      <a
                                        href={
                                          link.startsWith("http")
                                            ? link
                                            : `https://${link}`
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {link}
                                      </a>
                                    </div>
                                  ))}
                              </div>
                            ) : (
                              "-"
                            )}
                          </Descriptions.Item>

                          <Descriptions.Item label="Years working in your creative field">
                            {data.creative_experience || "-"}
                          </Descriptions.Item>

                          <Descriptions.Item label="Have you previously worked on beauty-adjacent creative projects?">
                            {formatBoolean(data.beauty_projects)}
                          </Descriptions.Item>

                          {data.beauty_projects && (
                            <Descriptions.Item label="If yes, briefly describe one example.">
                              {data.beauty_project_description || "-"}
                            </Descriptions.Item>
                          )}
                        </>
                      )}

                      {/* ===================================================== */}
                      {/* Breakthrough Track */}
                      {/* ===================================================== */}

                      {data.application_track === "breakthrough" && (
                        <>
                          <Descriptions.Item label="Is your organisation currently selling products or services in-market?">
                            {data.breakthrough_trading_status || "-"}
                          </Descriptions.Item>
                        </>
                      )}
                    </Descriptions>
                  )}

                  {/* ================================ */}
                  {/* Step 6 - Information */}
                  {/* ================================ */}

                  {((data.application_track === "brand" &&
                    (data.brand_track === "grow" ||
                      data.brand_track === "imagine")) ||
                    data.application_track === "design" ||
                    data.application_track === "breakthrough") && (
                    <Descriptions
                      title="Step 6 - Information"
                      bordered
                      column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                      size="small"
                      style={{ marginTop: 20 }}
                    >
                      {/* ================================ */}
                      {/* Step 6 - Grow Information */}
                      {/* ================================ */}
                      {data.application_track === "brand" &&
                        data.brand_track === "grow" && (
                          <>
                            <Descriptions.Item label="What is your company's elevator pitch?">
                              {data.grow_elevator_pitch || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="What problem are you solving and for whom?">
                              {data.grow_problem || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="What is genuinely different about your product?">
                              {data.grow_differentiation || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Who are the closest existing alternatives in the Indian market, and what gap are you filling that they don't?">
                              {data.grow_indian_market_opportunity || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="What were your most recent full-year revenues?">
                              {data.grow_last_full_year_revenue || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="What is your YoY revenue growth rate, and what is driving it?">
                              {data.grow_revenue_growth || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="What are your distribution channels and what % of revenue does each represent?">
                              {/* {data.grow_distribution_channels?.length
                                ? data.grow_distribution_channels
                                    .map(
                                      (c) =>
                                        `${c.channel || ""} (${
                                          c.percentage || 0
                                        }%)`,
                                    )
                                    .join(", ")
                                : "-"} */}
                              {renderDistributionChannels(
                                data.grow_distribution_channels
                              )}
                            </Descriptions.Item>

                            {data.grow_distribution_channels?.some(
                              (c) => c.channel === "Other"
                            ) && (
                              <Descriptions.Item label="What are your distribution channels and what % of revenue does each represent? (Other)">
                                {data.grow_distribution_channels_other || "-"}
                              </Descriptions.Item>
                            )}

                            <Descriptions.Item label="Repeat Purchase Rate (%)">
                              {data.grow_repeat_purchase_rate || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="CAC (₹)">
                              {data.grow_customer_acquisition_cost || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="AOV (₹)">
                              {data.grow_average_order_value || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Tell us about any external funding you've received or are actively pursuing.">
                              {/* {data.grow_external_funding?.length
                                ? data.grow_external_funding.join(", ")
                                : "-"} */}
                              {renderMultiChoice(data.grow_external_funding)}
                            </Descriptions.Item>

                            {data.grow_external_funding?.includes("Other") && (
                              <Descriptions.Item label="Tell us about any external funding you've received or are actively pursuing. (Other)">
                                {data.grow_external_funding_other || "-"}
                              </Descriptions.Item>
                            )}

                            <Descriptions.Item label="Why are you the right founder to lead this brand?">
                              {data.grow_founder_story || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Tell us about your team.">
                              {data.grow_team_description || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Where do you see your business in 3 years?">
                              {data.grow_three_year_vision || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="What is the single biggest risk to your business in the next 12–24 months, and how are you thinking about it?">
                              {data.grow_business_risks || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="How would you use the BEAUTY&YOU grant funding over the next 12 months?">
                              {data.grow_grant_usage || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Beyond funding, what would you most value from the BEAUTY&YOU ecosystem?">
                              {/* {data.grow_ecosystem_support?.length
                                ? data.grow_ecosystem_support.join(", ")
                                : "-"} */}
                              {renderMultiChoice(data.grow_ecosystem_support)}
                            </Descriptions.Item>

                            {data.grow_ecosystem_support?.includes("Other") && (
                              <Descriptions.Item label="Beyond funding, what would you most value from the BEAUTY&YOU ecosystem? (Other)">
                                {data.grow_ecosystem_support_other || "-"}
                              </Descriptions.Item>
                            )}

                            <Descriptions.Item label="Why should you win?">
                              {data.grow_win_reason || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="If shortlisted, would you be able to send 3 full sets of product ahead of time to ELC for evaluation?">
                              {formatBoolean(data.grow_product_samples)}
                            </Descriptions.Item>

                            <Descriptions.Item label="Anything else you'd like us to know?">
                              {data.grow_additional_information || "-"}
                            </Descriptions.Item>
                          </>
                        )}

                      {/* ================================ */}
                      {/* Step 6 - Imagine Information */}
                      {/* ================================ */}
                      {data.application_track === "brand" &&
                        data.brand_track === "imagine" && (
                          <>
                            <Descriptions.Item label="Describe your concept.">
                              {data.imagine_concept || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="What specific consumer problem are you solving?">
                              {data.imagine_consumer_problem || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Core formulation, ingredient, or format innovation">
                              {data.imagine_core_innovation || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="What stage is the concept at?">
                              {data.imagine_concept_stage || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Who is your target consumer?">
                              {data.imagine_target_consumer || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="How do you know this consumer exists, and roughly how many of them are there?">
                              {data.imagine_market_validation || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Who are the closest existing alternatives in the Indian market, and what gap are you filling that they don't?">
                              {data.imagine_market_gap || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Why are you the right person to build this?">
                              {data.imagine_founder_story || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="If you have a team, what experience does each member bring to this concept?">
                              {data.imagine_team_description || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Where do you see the brand in 3 years?">
                              {data.imagine_three_year_vision || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="What signals so far suggest this concept resonates?">
                              {data.imagine_current_traction || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Have you sold anything yet?">
                              {data.imagine_sales_stage || "-"}
                            </Descriptions.Item>

                            {data.imagine_sales_stage === "Other" && (
                              <Descriptions.Item label="Have you sold anything yet? (Other)">
                                {data.imagine_sales_stage_other || "-"}
                              </Descriptions.Item>
                            )}

                            {/* {(data.imagine_sales_stage ===
                              "Yes — small-batch or limited sales" ||
                              data.imagine_sales_stage ===
                                "Yes — but very early / pre-orders only" ||
                              data.imagine_sales_stage === "Other") && (
                              <Descriptions.Item label="If yes, please share details (channels, monthly sales, etc.)">
                                {data.imagine_sales_details || "-"}
                              </Descriptions.Item>
                            )} */}

                            <Descriptions.Item label="Tell us about any external funding you've received or are actively pursuing for this concept.">
                              {/* {data.imagine_external_funding?.length
                                ? data.imagine_external_funding.join(", ")
                                : "-"} */}
                              {renderMultiChoice(data.imagine_external_funding)}
                            </Descriptions.Item>

                            {data.imagine_external_funding?.includes(
                              "Other"
                            ) && (
                              <Descriptions.Item label="Tell us about any external funding you've received or are actively pursuing for this concept. (Other)">
                                {data.imagine_external_funding_other || "-"}
                              </Descriptions.Item>
                            )}

                            {/* <Descriptions.Item label="Provide details on funding amount, investor name, and date of close">
                              {data.imagine_external_funding_details || "-"}
                            </Descriptions.Item> */}

                            <Descriptions.Item label="What are you most uncertain about right now, and what would you want to learn or de-risk first?">
                              {data.imagine_biggest_uncertainty || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="How would you use the BEAUTY&YOU grant funding over the next 12 months?">
                              {data.imagine_grant_usage || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Beyond funding, what would you most value from the BEAUTY&YOU ecosystem?">
                              {/* {data.imagine_ecosystem_support?.length
                                ? data.imagine_ecosystem_support.join(", ")
                                : "-"} */}
                              {renderMultiChoice(
                                data.imagine_ecosystem_support
                              )}
                            </Descriptions.Item>

                            {data.imagine_ecosystem_support?.includes(
                              "Other"
                            ) && (
                              <Descriptions.Item label="Beyond funding, what would you most value from the BEAUTY&YOU ecosystem? (Other)">
                                {data.imagine_ecosystem_support_other || "-"}
                              </Descriptions.Item>
                            )}

                            <Descriptions.Item label="Why should you win?">
                              {data.imagine_win_reason || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Anything else you'd like us to know?">
                              {data.imagine_additional_information || "-"}
                            </Descriptions.Item>
                          </>
                        )}

                      {/* ================================ */}
                      {/* Step 6 - Design Information */}
                      {/* ================================ */}
                      {data.application_track === "design" && (
                        <>
                          <Descriptions.Item label="Upload 5–10 pieces of your strongest work">
                            {data.design_portfolio_files?.length > 0 ? (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 8,
                                }}
                              >
                                {data.design_portfolio_files.map(
                                  (file, index) => (
                                    <div
                                      key={index}
                                      style={{
                                        padding: "8px 12px",
                                        border: "1px solid #f0f0f0",
                                        borderRadius: 6,
                                        background: "#fafafa",
                                      }}
                                    >
                                      <a
                                        href={
                                          image_url + getStoredFileName(file)
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {getFileName(file)}
                                      </a>
                                    </div>
                                  )
                                )}
                              </div>
                            ) : (
                              "-"
                            )}
                          </Descriptions.Item>

                          <Descriptions.Item label="Pick one project from your portfolio and tell us the story behind it — the idea, your role, and the outcome.">
                            {data.design_portfolio_story || "-"}
                          </Descriptions.Item>

                          <Descriptions.Item label="If your work has appeared in any campaign, publication, exhibition, or product that reached the public, tell us about it.">
                            {data.design_public_work || "-"}
                          </Descriptions.Item>

                          <Descriptions.Item label="What is your point of view on the future of beauty in India? Where is it going, and what's missing?">
                            {data.design_future_of_beauty || "-"}
                          </Descriptions.Item>

                          <Descriptions.Item label="Share one idea for how a beauty brand could create a culturally relevant moment in India — a collection, packaging concept, pop-up, or experience.">
                            {data.design_cultural_idea || "-"}
                          </Descriptions.Item>

                          <Descriptions.Item label="What Indian cultural references, crafts, traditions, or communities inspire your work?">
                            {data.design_cultural_inspirations || "-"}
                          </Descriptions.Item>

                          <Descriptions.Item label="Upload a moodboard or visual that brings your idea in C2 to life">
                            {data.design_moodboard_files?.length > 0 ? (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 8,
                                }}
                              >
                                {data.design_moodboard_files.map(
                                  (file, index) => (
                                    <div
                                      key={index}
                                      style={{
                                        padding: "8px 12px",
                                        border: "1px solid #f0f0f0",
                                        borderRadius: 6,
                                        background: "#fafafa",
                                      }}
                                    >
                                      <a
                                        href={
                                          image_url + getStoredFileName(file)
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {getFileName(file)}
                                      </a>
                                    </div>
                                  )
                                )}
                              </div>
                            ) : (
                              "-"
                            )}
                          </Descriptions.Item>

                          <Descriptions.Item label="Have you collaborated with a brand or client before? Briefly describe one example.">
                            {data.design_brand_collaboration || "-"}
                          </Descriptions.Item>

                          <Descriptions.Item label="If selected as a finalist, you'll be given a creative brief and around 3–4 weeks to develop a response. Do you confirm you'd be available for this and for an in-person finalist presentation in September 2026?">
                            {data.design_finalist_availability || "-"}
                          </Descriptions.Item>

                          <Descriptions.Item label="Is there anything we should know about your capacity or working setup?">
                            {data.design_working_setup || "-"}
                          </Descriptions.Item>
                        </>
                      )}

                      {/* ================================ */}
                      {/* Step 6 - Breakthrough Information */}
                      {/* ================================ */}
                      {data.application_track === "breakthrough" && (
                        <>
                          <Descriptions.Item label="One-page technical overview of your innovation">
                            {data.breakthrough_technical_overview_files
                              ?.length > 0 ? (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 8,
                                }}
                              >
                                {data.breakthrough_technical_overview_files.map(
                                  (file, index) => (
                                    <div
                                      key={index}
                                      style={{
                                        padding: "8px 12px",
                                        border: "1px solid #f0f0f0",
                                        borderRadius: 6,
                                        background: "#fafafa",
                                      }}
                                    >
                                      <a
                                        href={
                                          image_url + getStoredFileName(file)
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {getFileName(file)}
                                      </a>
                                    </div>
                                  )
                                )}
                              </div>
                            ) : (
                              "-"
                            )}
                          </Descriptions.Item>

                          <Descriptions.Item label="Optional video link">
                            {renderLink(data.breakthrough_optional_video_url)}
                          </Descriptions.Item>

                          <Descriptions.Item label="Safety Data Sheet">
                            {data.breakthrough_safety_data_sheet_files?.length >
                            0 ? (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 8,
                                }}
                              >
                                {data.breakthrough_safety_data_sheet_files.map(
                                  (file, index) => (
                                    <div
                                      key={index}
                                      style={{
                                        padding: "8px 12px",
                                        border: "1px solid #f0f0f0",
                                        borderRadius: 6,
                                        background: "#fafafa",
                                      }}
                                    >
                                      <a
                                        href={
                                          image_url + getStoredFileName(file)
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {getFileName(file)}
                                      </a>
                                    </div>
                                  )
                                )}
                              </div>
                            ) : (
                              "-"
                            )}
                          </Descriptions.Item>

                          <Descriptions.Item label="Patent Reference">
                            {data.breakthrough_patent_reference_files?.length >
                            0 ? (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 8,
                                }}
                              >
                                {data.breakthrough_patent_reference_files.map(
                                  (file, index) => (
                                    <div
                                      key={index}
                                      style={{
                                        padding: "8px 12px",
                                        border: "1px solid #f0f0f0",
                                        borderRadius: 6,
                                        background: "#fafafa",
                                      }}
                                    >
                                      <a
                                        href={
                                          image_url + getStoredFileName(file)
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {getFileName(file)}
                                      </a>
                                    </div>
                                  )
                                )}
                              </div>
                            ) : (
                              "-"
                            )}
                          </Descriptions.Item>

                          <Descriptions.Item label="Scientific publications, technical papers, or research documentation">
                            {data.breakthrough_scientific_publication_files
                              ?.length > 0 ? (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 8,
                                }}
                              >
                                {data.breakthrough_scientific_publication_files.map(
                                  (file, index) => (
                                    <div
                                      key={index}
                                      style={{
                                        padding: "8px 12px",
                                        border: "1px solid #f0f0f0",
                                        borderRadius: 6,
                                        background: "#fafafa",
                                      }}
                                    >
                                      <a
                                        href={
                                          image_url + getStoredFileName(file)
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {getFileName(file)}
                                      </a>
                                    </div>
                                  )
                                )}
                              </div>
                            ) : (
                              "-"
                            )}
                          </Descriptions.Item>

                          <Descriptions.Item label="What best describes the technology type of your innovation?">
                            {/* {data.breakthrough_technology_types?.length
                              ? data.breakthrough_technology_types.join(", ")
                              : "-"} */}
                            {renderMultiChoice(
                              data.breakthrough_technology_types
                            )}
                          </Descriptions.Item>

                          {data.breakthrough_technology_types?.includes(
                            "Other"
                          ) && (
                            <Descriptions.Item label="What best describes the technology type of your innovation? (Other)">
                              {data.breakthrough_technology_type_other || "-"}
                            </Descriptions.Item>
                          )}

                          <Descriptions.Item label="What best describes the primary application area of your innovation?">
                            {/* {data.breakthrough_primary_application_areas?.length
                              ? data.breakthrough_primary_application_areas.join(
                                  ", ",
                                )
                              : "-"} */}
                            {renderMultiChoice(
                              data.breakthrough_primary_application_areas
                            )}
                          </Descriptions.Item>

                          {data.breakthrough_primary_application_areas?.includes(
                            "Other"
                          ) && (
                            <Descriptions.Item label="What best describes the primary application area of your innovation? (Other)">
                              {data.breakthrough_primary_application_area_other ||
                                "-"}
                            </Descriptions.Item>
                          )}

                          <Descriptions.Item label="What is the Technology Readiness Level (TRL) of your innovation?">
                            {data.breakthrough_trl || "-"}
                          </Descriptions.Item>

                          <Descriptions.Item label="How would you best describe the scope of your innovation?">
                            {data.breakthrough_innovation_scope?.toLowerCase() ===
                            "both" ? (
                              <>
                                <div>
                                  <strong>Both</strong>
                                </div>
                                <div style={{ marginLeft: 16 }}>
                                  <div>
                                    • Developed specifically for fragrance
                                    application
                                  </div>
                                  <div>
                                    • Enabling / platform technology applicable
                                    across multiple sectors
                                  </div>
                                </div>
                              </>
                            ) : (
                              data.breakthrough_innovation_scope || "-"
                            )}
                          </Descriptions.Item>

                          <Descriptions.Item label="Which of the following describe your innovation's known fragrance compatibility or formulation properties?">
                            {/* {data.breakthrough_formulation_properties?.length
                              ? data.breakthrough_formulation_properties.join(
                                  ", ",
                                )
                              : "-"} */}
                            {renderMultiChoice(
                              data.breakthrough_formulation_properties
                            )}
                          </Descriptions.Item>

                          {data.breakthrough_formulation_properties?.includes(
                            "Other"
                          ) && (
                            <Descriptions.Item label="Which of the following describe your innovation's known fragrance compatibility or formulation properties? (Other)">
                              {data.breakthrough_formulation_property_other ||
                                "-"}
                            </Descriptions.Item>
                          )}

                          <Descriptions.Item label="Which of the following fragrance benefits does your innovation address or enable?">
                            {/* {data.breakthrough_fragrance_benefits?.length
                              ? data.breakthrough_fragrance_benefits.join(", ")
                              : "-"} */}
                            {renderMultiChoice(
                              data.breakthrough_fragrance_benefits
                            )}
                          </Descriptions.Item>

                          {data.breakthrough_fragrance_benefits?.includes(
                            "Other"
                          ) && (
                            <Descriptions.Item label="Which of the following fragrance benefits does your innovation address or enable? (Other)">
                              {data.breakthrough_fragrance_benefit_other || "-"}
                            </Descriptions.Item>
                          )}

                          <Descriptions.Item label="How does your approach compare to existing solutions?">
                            {/* {data.breakthrough_solution_comparison?.length
                              ? data.breakthrough_solution_comparison.join(", ")
                              : "-"} */}
                            {renderMultiChoice(
                              data.breakthrough_solution_comparison
                            )}
                          </Descriptions.Item>

                          {data.breakthrough_solution_comparison?.includes(
                            "Other"
                          ) && (
                            <Descriptions.Item label="How does your approach compare to existing solutions? (Other)">
                              {data.breakthrough_solution_comparison_other ||
                                "-"}
                            </Descriptions.Item>
                          )}

                          <Descriptions.Item label="Briefly describe how your approach compares:">
                            {data.breakthrough_solution_comparison_description ||
                              "-"}
                          </Descriptions.Item>

                          <Descriptions.Item label="What evidence do you have that your innovation works?">
                            {/* {data.breakthrough_supporting_evidence?.length
                              ? data.breakthrough_supporting_evidence.join(", ")
                              : "-"} */}
                            {renderMultiChoice(
                              data.breakthrough_supporting_evidence
                            )}
                          </Descriptions.Item>

                          {data.breakthrough_supporting_evidence?.includes(
                            "Other"
                          ) && (
                            <Descriptions.Item label="What evidence do you have that your innovation works? (Other)">
                              {data.breakthrough_supporting_evidence_other ||
                                "-"}
                            </Descriptions.Item>
                          )}

                          <Descriptions.Item label="What end-user or consumer need does your innovation ultimately address?">
                            {/* {data.breakthrough_consumer_needs?.length
                              ? data.breakthrough_consumer_needs.join(", ")
                              : "-"} */}
                            {renderMultiChoice(
                              data.breakthrough_consumer_needs
                            )}
                          </Descriptions.Item>

                          {data.breakthrough_consumer_needs?.includes(
                            "Other"
                          ) && (
                            <Descriptions.Item label="What end-user or consumer need does your innovation ultimately address?">
                              {data.breakthrough_consumer_need_other || "-"}
                            </Descriptions.Item>
                          )}

                          {/* <Descriptions.Item label="Briefly describe how your approach compares:">
                            {data.breakthrough_consumer_need_description || "-"}
                          </Descriptions.Item> */}

                          <Descriptions.Item label="What is the current status of your prototype, sample, or demonstration material?">
                            {data.breakthrough_prototype_status || "-"}
                          </Descriptions.Item>

                          <Descriptions.Item label="What is the IP status of your innovation?">
                            {data.breakthrough_ip_status || "-"}
                          </Descriptions.Item>

                          {(data.breakthrough_ip_status ===
                            "Granted patent(s)" ||
                            data.breakthrough_ip_status ===
                              "Patent application(s) filed, pending") && (
                            <Descriptions.Item label="Patent Reference Number / Details:">
                              {data.breakthrough_ip_reference_details || "-"}
                            </Descriptions.Item>
                          )}

                          <Descriptions.Item label="In which regions is your innovation registered, approved, cleared, or actively seeking registration?">
                            {/* {data.breakthrough_registered_regions?.length
                              ? data.breakthrough_registered_regions.join(", ")
                              : "-"} */}
                            {renderMultiChoice(
                              data.breakthrough_registered_regions
                            )}
                          </Descriptions.Item>

                          {data.breakthrough_registered_regions?.includes(
                            "Other"
                          ) && (
                            <Descriptions.Item label="In which regions is your innovation registered, approved, cleared, or actively seeking registration? (Other)">
                              {data.breakthrough_registered_region_other || "-"}
                            </Descriptions.Item>
                          )}

                          <Descriptions.Item label="Do you have scientific publications, technical papers, or research documentation supporting your innovation?">
                            {formatBoolean(data.breakthrough_has_publications)}
                          </Descriptions.Item>

                          {data.breakthrough_has_publications === true && (
                            <Descriptions.Item label="If Yes, list titles, journals, DOIs, or URLs:">
                              {data.breakthrough_publications_details || "-"}
                            </Descriptions.Item>
                          )}

                          <Descriptions.Item label="Are you open to exclusivity or a preferential collaboration arrangement with a single partner organisation?">
                            {/* {data.breakthrough_collaboration_preferences?.length
                              ? data.breakthrough_collaboration_preferences.join(
                                  ", ",
                                )
                              : "-"} */}
                            {renderMultiChoice(
                              data.breakthrough_collaboration_preferences
                            )}
                          </Descriptions.Item>

                          <Descriptions.Item label="Briefly describe your team background">
                            {data.breakthrough_team_background || "-"}
                          </Descriptions.Item>

                          <Descriptions.Item label="What funding or institutional support have you received to date?">
                            {/* {data.breakthrough_funding_support?.length
                              ? data.breakthrough_funding_support.join(", ")
                              : "-"} */}
                            {renderMultiChoice(
                              data.breakthrough_funding_support
                            )}
                          </Descriptions.Item>

                          {data.breakthrough_funding_support?.includes(
                            "Other"
                          ) && (
                            <Descriptions.Item label="What funding or institutional support have you received to date? (Other)">
                              {data.breakthrough_funding_support_other || "-"}
                            </Descriptions.Item>
                          )}

                          {isCompanyType && (
                            <>
                              <Descriptions.Item label="Have you previously collaborated, or are you in active collaboration, with a large corporate organisation on a technology development, licensing, or pilot project?">
                                {formatBoolean(
                                  data.breakthrough_has_corporate_collaboration
                                )}
                              </Descriptions.Item>

                              {data.breakthrough_has_corporate_collaboration && (
                                <Descriptions.Item label="If Yes, briefly describe (type of organisation, nature of collaboration). You do not need to name the organisation.">
                                  {data.breakthrough_corporate_collaboration_details ||
                                    "-"}
                                </Descriptions.Item>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </Descriptions>
                  )}

                  {/* ================================ */}
                  {/* Step 7 - Visionary Women's Award */}
                  {/* ================================ */}

                  {data.has_woman_founder === true &&
                    data.visionary_opt_out === false && (
                      <Descriptions
                        title="Step 7 - Visionary Women's Award"
                        bordered
                        column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                        size="small"
                        style={{ marginTop: 20 }}
                      >
                        <Descriptions.Item label="Tell us about your founder story — What inspired you to build this business, and how have your experiences as a woman founder shaped the kind of leader you are today?">
                          {data.visionary_founder_story || "-"}
                        </Descriptions.Item>

                        <Descriptions.Item label="What is one breakthrough or milestone in your leadership journey that you're especially proud of, and what did it take to achieve it?">
                          {data.visionary_leadership_milestone || "-"}
                        </Descriptions.Item>

                        <Descriptions.Item label="How does your business address unmet needs or challenges faced by women consumers in beauty, and what unique insight or lived experience do you bring to solving these issues?">
                          {data.visionary_women_consumer_challenge || "-"}
                        </Descriptions.Item>

                        <Descriptions.Item label="How is your business creating opportunities or advancing progress for other women — through your team, supply chain, partnerships, community, or broader beauty industry?">
                          {data.visionary_women_empowerment || "-"}
                        </Descriptions.Item>

                        <Descriptions.Item label="Which of the following apply to your business?">
                          {/* {data.visionary_business_attributes?.length
                            ? data.visionary_business_attributes.join(", ")
                            : "-"} */}
                          {renderMultiChoice(
                            data.visionary_business_attributes
                          )}
                        </Descriptions.Item>

                        <Descriptions.Item label="What is your vision for your business in 3 years, and how would the Visionary Women's Award and BEAUTY&YOU platform help accelerate that growth and impact?">
                          {data.visionary_three_year_vision || "-"}
                        </Descriptions.Item>

                        <Descriptions.Item label="Is there anything else you'd like us to know about yourself, your business, or the impact you hope to create as a woman founder?">
                          {data.visionary_additional_information || "-"}
                        </Descriptions.Item>
                      </Descriptions>
                    )}
                </>
              )}
            </Drawer>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default Index;
